import React from 'react';

import { StyledLink } from './styled';

type Props = {
  mail: string;
  text?: string;
};

const MailtoLink = ({ mail, text }: Props): JSX.Element => {
  const handleClick = (): void => {
    window.location.href = `mailto:${mail}`;
  };

  return (
    <StyledLink onClick={handleClick} data-testid="mailtoLink">
      {text || mail}
    </StyledLink>
  );
};

export default MailtoLink;
